import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2025 Satta Wala Fixed No. All Rights Reserved.</p>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/about-us">About Us</a>
          <a href="/contact-us">Contact</a>
          <a href="/disclaimer">Disclaimer</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-conditions">Terms Conditions</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
